import { render } from "./NotAdmin.vue?vue&type=template&id=0ce44049&scoped=true&ts=true"
import script from "./NotAdmin.vue?vue&type=script&lang=ts"
export * from "./NotAdmin.vue?vue&type=script&lang=ts"

import "./NotAdmin.vue?vue&type=style&index=0&id=0ce44049&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce44049"]])

export default __exports__